import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';

import ButtonGroup from '../../components/Button/ButtonGroup';
import ButtonToggleValue from '../../components/Button/ButtonToggleValue';
import ColorPicker from '../../components/ColorPicker/ColorPicker';
import BorderStyleDropdown from '../../components/Dropdown/BorderStyleDropdown';
import Select from '../../components/Dropdown/Select';
import TextAlignDropdown from '../../components/Dropdown/TextAlignDropdown';

import FieldSection from './FieldSection';
import FieldSectionToggle from './FieldSectionToggle';

function CommonStyle() {
	const dispatch = useDispatch();
	const editor = useSelector((state: RootState) => state.editor);
	const container = useSelector((state: RootState) => state.editor.container);
	const styleTargetContainer = `container`;

	return (
		<div className="editor-sidebar-common-style">

			<FieldSection
				labelName="전체 배경 색상"
			>
				<ColorPicker
					target={`${styleTargetContainer}/backgroundFull`}
					value={container?.backgroundFull}
					position="right"
				>배경</ColorPicker>
			</FieldSection>

			<h3 className="field-section-title">
				본문
			</h3>

			<FieldSection
				labelName="배경 색상"
				labelSize="small"
			>
				<ColorPicker
					target={`${styleTargetContainer}/background`}
					value={container?.background}
					position="right"
				>배경</ColorPicker>
			</FieldSection>

			<FieldSection
				labelName="테두리"
				labelSize="small"
			>
				<Select
					target={`${styleTargetContainer}/borderWidth`}
					value={container?.borderWidth}
					options={editor.option.borderWidth}
					size="small"
				/>
				<ColorPicker
					target={`${styleTargetContainer}/borderColor`}
					value={container?.borderColor}
					position="right"
				>테두리</ColorPicker>
			</FieldSection>

			<h3 className="field-section-title">
				상자
			</h3>

			<div className="box-padding-field">
			
				<FieldSection
					labelName="내부 여백 상단"
					layout="vertical"
					labelSize="small"
				>
					<Select
						target={`commonStyle/box/paddingTop`}
						value={container?.commonStyle?.box?.paddingTop}
						options={editor.option.boxPadding}
					/>
				</FieldSection>
	
				<FieldSection
					labelName="내부 여백 하단"
					layout="vertical"
					labelSize="small"
				>
					<Select
						target={`commonStyle/box/paddingBottom`}
						value={container?.commonStyle?.box?.paddingBottom}
						options={editor.option.boxPadding}
					/>
				</FieldSection>
	
				<FieldSection
					labelName="좌우 여백"
					layout="vertical"
					labelSize="small"
				>
					<Select
						target={`commonStyle/box/paddingLeft`}
						value={container?.commonStyle?.box?.paddingLeft}
						options={editor.option.boxPadding}
					/>
				</FieldSection>
			</div>

			<h3 className="field-section-title">
				구성 요소
			</h3>

			<FieldSectionToggle
				labelName="기본 텍스트"
				value={container?.commonStyle?.text}
			>
				<div className="row">
					<Select
						target={`commonStyle/text/fontFamily`}
						value={container?.commonStyle?.text?.fontFamily}
						options={editor.option.fontFamily}
						size="small"
					/>
					<Select
						target={`commonStyle/text/fontSize`}
						value={container?.commonStyle?.text?.fontSize}
						options={editor.option.fontSize.filter((item:any) => item.value <= 26 )}
						size="small"
					/>
					<TextAlignDropdown
						target={`commonStyle/text/textAlign`}
						value={container?.commonStyle?.text?.textAlign}
						options={editor.option.textAlign}
						size="tiny"
					/>
					<ColorPicker
						target={`commonStyle/text/color`}
						value={container?.commonStyle?.text?.color}
						position="right"
						showResetValue={false}
					>color</ColorPicker>
				</div>
			</FieldSectionToggle>

			<FieldSectionToggle
				labelName="링크 텍스트"
				value={container?.commonStyle?.link}
			>
				<div className="row">
					<div className="btn-group">
						<ButtonToggleValue 
							imagePath="icon/common_style/linkstyle_"
							value={container?.commonStyle?.link?.fontWeight}
							target={`commonStyle/link/fontWeight`}
							name="bold"
						/>
						<ButtonToggleValue
							imagePath="icon/common_style/linkstyle_"
							value={container?.commonStyle?.link?.textDecoration}
							target={`commonStyle/link/textDecoration`}
							name="underline"
						/>
						<ButtonToggleValue
							imagePath="icon/common_style/linkstyle_"
							value={container?.commonStyle?.link?.textDecoration}
							target={`commonStyle/link/textDecoration`}
							name="line-through"
						/>
					</div>
					<ColorPicker
						target={`commonStyle/link/color`}
						value={container?.commonStyle?.link?.color}
						position="left"
						showResetValue={false}
					>color</ColorPicker>
				</div>
			</FieldSectionToggle>
			<FieldSectionToggle
				labelName="버튼 스타일"
				value={container?.commonStyle?.button}
			>
				<FieldSection
					labelName="테두리"
				>
					<Select
						target={`commonStyle/button/borderWidth`}
						value={container?.commonStyle?.button?.borderWidth}
						options={editor.option.borderWidth}
						size="small"
					/>
					<ColorPicker
						target={`commonStyle/button/borderColor`}
						value={container?.commonStyle?.button?.borderColor}
						position="right"
					>테두리</ColorPicker>
				</FieldSection>

				<FieldSection
					labelName="배경 색상"
				>
					<ColorPicker
						target={`commonStyle/button/background`}
						value={container?.commonStyle?.button?.background}
						position="right"
					>배경</ColorPicker>
				</FieldSection>

				<FieldSection
					labelName="텍스트"
					layout="horizontal"
				>
					<Select
						target={`commonStyle/button/fontFamily`}
						value={container?.commonStyle?.button?.fontFamily}
						options={editor.option.fontFamily}
						size="small"
					/>
					<Select
						target={`commonStyle/button/fontSize`}
						value={container?.commonStyle?.button?.fontSize}
						options={editor.option.fontSize.filter((item: any) => item.value <= 26)}
						size="small"
					/>
					<ColorPicker
						target={`commonStyle/button/color`}
						value={container?.commonStyle?.button?.color}
						position="right"
						showResetValue={false}
					>배경</ColorPicker>
				</FieldSection>

				<FieldSection
					labelName="정렬"
				>
					<div className="btn-group">
						<ButtonToggleValue
							target={`commonStyle/button/fullWidth`}
							imagePath="icon/common_style/fullWidth_"
							value={container?.commonStyle?.button?.fullWidth}
							name="100%"
						/>
					</div>
					<ButtonGroup
						target={`commonStyle/button/textAlign`}
						value={container?.commonStyle?.button?.textAlign}
						options={editor.option.ctaAlign}
						imagePath="icon/common_style/button_align_"
						disabled={container?.commonStyle?.button?.width === '100%'}
					/>
				</FieldSection>

				<FieldSection
					labelName="모양"
				>
					<Select
						target={`commonStyle/button/buttonType`}
						value={container?.commonStyle?.button?.buttonType}
						options={editor.option.buttonType}
					/>
				</FieldSection>
				{/* <FieldSection
						labelName="내부 여백"
					>
						...
					</FieldSection> */}
			</FieldSectionToggle>

			<FieldSectionToggle
				labelName="구분선"
				value={container?.commonStyle?.partition}
			>
				<div className="row">
					<BorderStyleDropdown
						target={`commonStyle/partition/borderTopStyle`}
						value={container?.commonStyle?.partition?.borderTopStyle}
						option={editor.option.borderStyle}
					/>
					<Select
						target={`commonStyle/partition/borderTopWidth`}
						value={container?.commonStyle?.partition?.borderTopWidth}
						options={editor.option.borderWidthPartition}
						size="medismall"
					/>
					<ColorPicker
						target={`commonStyle/partition/borderTopColor`}
						value={container?.commonStyle?.partition?.borderTopColor}
						position="right"
						showResetValue={false}
					>테두리</ColorPicker>
				</div>
			</FieldSectionToggle>
			
		</div>
	);
}

export default CommonStyle;